import { variantProvider } from '@/app'
import { APIClient } from '@/services'
import { CommunityFeed } from '@/types'
import { communityAnalytics, formatNumberToShort } from '@/utils'
import { memo, useCallback, useMemo, useRef, useState } from 'react'
import { ActionButton } from '../../atoms/ActionButton'

const UnMemoizedLike = ({ item }: { item: CommunityFeed }) => {
  const [liked, setLiked] = useState(item?.liked)

  const likeTimeout = useRef<NodeJS.Timeout | null>(null)

  const handleLike = useCallback(() => {
    const authorized = APIClient.UnknownProfile.maybeOpenRegistrationWall()

    if (!authorized) return

    let nextLiked = null

    setLiked(currentLiked => {
      nextLiked = !currentLiked
      return !currentLiked
    })

    if (likeTimeout.current) {
      clearTimeout(likeTimeout.current)
      likeTimeout.current = null
    }

    likeTimeout.current = setTimeout(() => {
      APIClient.Community.communityOperations.mutations.toggleLike({
        postId: item?.id,
        to: nextLiked,
      })

      communityAnalytics.feedActionEvent('feed_like', item, { liked: nextLiked })
    }, 1000)
  }, [])

  const likeCount = useMemo(() => {
    const initialLikeCount = item.liked ? item.likes - 1 : item.likes

    const likeCount = initialLikeCount + (liked ? 1 : 0)

    return formatNumberToShort(likeCount)
  }, [liked])

  return (
    <ActionButton
      icon='like'
      text={likeCount}
      onPress={handleLike}
      iconStyle={liked ? styles.likedIcon : null}
    />
  )
}

export const Like = memo(UnMemoizedLike)

const styles = variantProvider.createComponentStyle(theme => ({
  likedIcon: {
    color: theme.colors.destructive2,
  },
}), true)
